/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./video-project.vue?vue&type=template&id=95d58cb0&scoped=true&"
import script from "./video-project.vue?vue&type=script&lang=js&"
export * from "./video-project.vue?vue&type=script&lang=js&"
import style0 from "./video-project.vue?vue&type=style&index=0&id=95d58cb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d58cb0",
  null
  
)

export default component.exports